import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RequisitosRespaldosService } from '../../../../_services/requisitos-respaldos.service';
import { SolicitudUcRespaldoAdjuntoService } from '../../../../_services/solicitud-uc-respaldo-adjunto.service';
import { AdministradorDocumentoService } from '../../../../_services/administrador-documento.service';
import { ConstanteService } from '../../../../_services/constante.service';
import { NavService } from '../../../../_services/_nav.service';
import { RolFuncionalitiesServices } from '../../../../_services/rol-funcionalidad.service';
import { AutenticacionService } from '../../../../_services/autenticacion.service';
import { AdjuntoService } from '../../../../_services/adjunto.service';
import { ListaService } from '../../../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ListAdjunto } from '../../../../_models/requisito-garantia-respaldo';
import { AdministradorDocumento } from '../../../../_models/administrador-documento';
import { TipoVigencia } from '../../../../_enums/enum';
import { SolicitudUnidadCredito } from "../../../../_models/solicitud-unidad-credito";
import { RequisitosService } from "../../../../_services/requisitos.service";
import { AdjuntoUnificado } from "../../../../_models/adjunto-unificado";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../../../../proyect.conf';
import { TerceroAdjuntoService } from '../../../../_services/tercero-adjunto.service';
import { SolicitudUnidadCreditoControlAdjuntoService } from '../../../../_services/solicitud-unidad-credito-control-adjunto.service';
import { ProductoControlService } from '../../../../_services/producto-control.service';
import { ControlService } from '../../../../_services/control.service';
import { Control } from '../../../../_models/control';
import { TerceroDocumentoRelacion } from '../../../../_models/tercero-documento-relacion';
import { SolicitudUnidadCreditoControlAdjunto } from '../../../../_models/solicitud-unidad-credito-control-adjunto';
import { SolicitudUcRespaldoAdjunto } from '../../../../_models/solicitud-uc-respaldo-adjunto';
import { SolicitudUnidadCreditoService } from '../../../../_services/solicitud-unidad-credito.service';
import { TerceroUpPasarelaAdjuntoService } from '../../../../_services/tercero-up-pasarela-adjunto.service';
import { TerceroUPPasarelaAdjunto } from '../../../../_models/tercero-up-pasarela-adjunto';

@Component({
  selector: 'app-matrix-gestion-adjuntos-modal',
  templateUrl: './matrix-gestion-adjuntos-modal.component.html',
  styleUrls: ['./matrix-gestion-adjuntos-modal.component.scss']
})
export class MatrixGestionAdjuntosModalComponent implements OnInit {

  idPlataforma: string;
  idSolicitud: string;
  solUnidadCredito: SolicitudUnidadCredito;
  idFase: string;
  idProducto: string;
  detalle: boolean = false;
  esPasarela = false;
  idTerceroUPPasarela = '';

  cargando = true;
  listaAdjuntos: any[] = [];
  listaOriginal: any[] = [];
  ftype = '';

  // Secciones
  listaMinimos: any[] = [];
  listaAdicionales: any[] = [];

  // Agregar Form
  verPantallaAgregar = false;
  listaRespaldosAdicionales: SelectItem[] = [];
  listaRespaldosAdicionalesTodos: AdministradorDocumento[] = [];
  formulario: FormGroup;
  submitted = false;

  // Búsqueda
  textoBusqueda = '';

  // Seleccionar todos (retoma)
  checkTodos = false;

  // Vista adjunto
  showModalAdjunto = false;
  verRegistro: any;
  fileUrl: SafeResourceUrl;
  loadingFile = false;

  // Visor pasarela
  mostrarVisorPasarela = false;
  adjuntoSeleccionadoPasarela: any = null;

  permisoGestionAdjuntos = false;

  // URL upload
  public svcThUrl = AppSettings.rutServiciosADJ + "/api/adjuntos";
  public svcThUrlTercero = AppSettings.rutServiciosTER + "/api/adjuntosTerceros";
  public nomArchivo = "";

  listaControles: Control[] = [];

  // Medios Notificaciones
  listaMediosNotificaciones: SelectItem[] = [];
  medioNotificacionSelected: string = null;

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private fb: FormBuilder,
    private requisitosRespaldos: RequisitosRespaldosService,
    private solicitudUcRespaldoAdjuntoService: SolicitudUcRespaldoAdjuntoService,
    private administradorDocumentoService: AdministradorDocumentoService,
    private constanteService: ConstanteService,
    private adjService: AdjuntoService,
    private navService: NavService,
    private rolFuncionalidadService: RolFuncionalitiesServices,
    private authService: AutenticacionService,
    private sanitizer: DomSanitizer,
    private confirmService: ConfirmationService,
    private requisitoService: RequisitosService,
    private terceroAdjuntoService: TerceroAdjuntoService,
    private solUcControlAdjuntoService: SolicitudUnidadCreditoControlAdjuntoService,
    private prodControlService: ProductoControlService,
    private controlService: ControlService,
    private listaService: ListaService,
    private solicitudUnidadCreditoService: SolicitudUnidadCreditoService,
    private terceroUpPasarelaAdjuntoService: TerceroUpPasarelaAdjuntoService
  ) {}

  ngOnInit(): void {
    this.idPlataforma = this.config.data?.idPlataforma;
    this.idSolicitud = this.config.data?.idSolicitud;
    this.solUnidadCredito = this.config.data?.solUnidadCredito;
    this.idFase = this.config.data?.idFase;
    this.idProducto = this.config.data?.idProducto;
    this.detalle = this.config.data?.detalle;
    this.esPasarela = !!this.config.data?.esPasarela;
    this.idTerceroUPPasarela = this.config.data?.idTerceroUPPasarela || '';

    this.cargarForm();

    forkJoin([
      this.cargarRequisitos(),
      this.constanteService.getByCode('FTYPE'),
      this.controlService.listadoHabilitados(),
      this.listaService.getMasterDetails('ListasMediosNotificaciones')
    ]).subscribe(([voidf, data, controles, mediosNotificaciones]) => {
      if (data && data.valor) {
        this.ftype = data.valor;
      }

      this.listaControles = controles || [];

      if (mediosNotificaciones) {
        this.listaMediosNotificaciones = mediosNotificaciones.map((t: any) => ({
          label: t.nombre,
          value: t.codigo
        }));
      }

      this.cargarAdicionales();
      this.cargando = false;
    });
  }

  get f() {
    return this.formulario.controls;
  }

  /**
   * Inicializa el formulario reactivo para la adición de documentos de respaldo adicionales.
   */
  cargarForm(): void {
    this.formulario = this.fb.group({
      idRequisito: [null, [Validators.required]],
      descripcion: [null, []]
    });
  }

  /**
   * Carga los recaudos según el contexto del producto.
   * En Pasarela consulta los adjuntos del titular en pasarela; en otros productos consulta
   * los requisitos unificados de la solicitud de crédito.
   */
  async cargarRequisitos() {
    try {
      if (this.esPasarela && this.idTerceroUPPasarela) {
        const [ adjuntosPasarela, documentos, permisoGestionAdjuntos ] = await firstValueFrom(
          forkJoin([
            this.terceroUpPasarelaAdjuntoService.listAdjuntos(this.idTerceroUPPasarela),
            this.administradorDocumentoService.getAllEnable(),
            this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('FABCRE', 'SOPVAL', 'GESADJ'),
          ])
        );
        this.listaRespaldosAdicionalesTodos = documentos || [];
        const roles = permisoGestionAdjuntos || [];
        this.permisoGestionAdjuntos = !!roles.find(
          x => !!this.authService.obtenerRolesUsuarios().find(y => x.codigoRol === y)
        );
        this.listaAdjuntos = [];
        for (const adjunto of (adjuntosPasarela || [])) {
          const objRequisito = this.mapearAdjuntoPasarelaAObjetoRequisito(adjunto);
          this.listaAdjuntos.push(objRequisito);
        }
        this.listaOriginal = this.listaAdjuntos.map(x => Object.assign({}, x));
        return;
      }

      const requisito = await firstValueFrom(this.requisitoService.obtenerPorUnidadCredito(this.solUnidadCredito.idSolicitudUnidadCredito));
      const [ adjuntosUnificados, documentos, permisoGestionAdjuntos ] = await firstValueFrom(
        forkJoin([
          requisito ?
            this.solicitudUcRespaldoAdjuntoService.obtenerAdjuntosRequisitoGarantia(requisito.idRequisitoGarantia, this.solUnidadCredito.idSolicitudUnidadCredito, this.detalle) :
            this.solicitudUcRespaldoAdjuntoService.obtenerAdjuntosRequisitoSinGarantia(this.solUnidadCredito.idSolicitudUnidadCredito, this.detalle),
          this.administradorDocumentoService.getAllEnable(),
          this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('FABCRE', 'SOPVAL', 'GESADJ'),
        ])
      );
      this.listaRespaldosAdicionalesTodos = documentos
      const roles = permisoGestionAdjuntos || [];
      this.permisoGestionAdjuntos = !!roles.find(
          x => !!this.authService.obtenerRolesUsuarios().find(y => x.codigoRol === y)
      );;
      this.listaAdjuntos = [];
      for (const adjunto of adjuntosUnificados) {
        const objRequisito = this.mapearAdjuntoAObjetoRequisito(adjunto);
        this.listaAdjuntos.push(objRequisito);
      }
      this.listaOriginal = this.listaAdjuntos.map(x => Object.assign({}, x));
    } catch (error) {
      this.listaAdjuntos = [];
      return;
    }
  }

  /**
   * Transforma un registro de TerceroUPPasarelaAdjunto al formato requerido por la vista modal,
   * normalizando indicadores de obligatoriedad, retoma y estado calificado/verificado.
   */
  mapearAdjuntoPasarelaAObjetoRequisito(adjunto: TerceroUPPasarelaAdjunto): any {
    const documentoAdmin = this.listaRespaldosAdicionalesTodos.find(
      (x) => x.codigo === adjunto.codigo || x.idDocumentoTercero === adjunto.idDocumentoTercero
    );

    const tieneAdjunto = !!adjunto.idAdjunto;

    return {
      ...adjunto,
      nombreRespaldo: adjunto.nombre || documentoAdmin?.nombre || adjunto.documento,
      idRespaldo: adjunto.idRespaldo || adjunto.idDocumentoTercero,
      descripcionRespaldo: adjunto.descripcionAdjunto || documentoAdmin?.descripcion || '',
      ordenRespaldo: adjunto.orden || 0,
      idAdjunto: adjunto.idAdjunto,
      indicadorHabilitadoAdjunto: tieneAdjunto,
      codigo: adjunto.codigo || adjunto.codigoDocumento,
      adicional: !adjunto.indicadorObligatorio,
      indicadorRetoma: false,
      indicadorObligatorio: !!adjunto.indicadorObligatorio,
      indicadorTercero: adjunto.indicadorTercero ?? false,
      codigoTipoVigencia: adjunto.codigoTipoVigencia,
      fechaAdjunto: adjunto.fechaAdjunto,
      tipoVigencia: tieneAdjunto ? (adjunto.tipoVigencia || 'Verificado') : adjunto.tipoVigencia,
      validacionPermisos: true,
      indicadorSolicitarCliente: adjunto.indicadorSolicitarCliente ?? documentoAdmin?.indicadorSolicitarCliente ?? false,
      idDocumentoTercero: adjunto.idDocumentoTercero,
      idTerceroUPPasarela: adjunto.idTerceroUPPasarela || this.idTerceroUPPasarela,
      idTerceroUPPasarelaAdjunto: adjunto.idTerceroUPPasarelaAdjunto,
      idTercerosUPPasarelasAdjuntosVersion: adjunto.idTercerosUPPasarelasAdjuntosVersion,
      esPasarela: true,
      objOriginal: { ...adjunto }
    };
  }

  /**
   * Construye el payload común para crear una nueva versión de adjunto o inhabilitarlo en Pasarela.
   */
  construirRegistroAdjuntoPasarela(
    base: any,
    idAdjunto: string | null,
    indicadorHabilitado = true
  ): Partial<TerceroUPPasarelaAdjunto> & { idtercerosUPPasarelasAdjuntos?: string; indicadorHabilitado?: boolean } {
    return {
      idTerceroUPPasarela: this.idTerceroUPPasarela,
      idTerceroUPPasarelaAdjunto: base.idTerceroUPPasarelaAdjunto,
      idTercerosUPPasarelasAdjuntosVersion: base.idTercerosUPPasarelasAdjuntosVersion,
      idDocumentoTercero: base.idDocumentoTercero,
      codigo: base.codigo,
      nombre: base.nombre || base.nombreRespaldo,
      codigoTipoVigencia: base.codigoTipoVigencia,
      tipoVigencia: base.tipoVigencia,
      indicadorSolicitarCliente: base.indicadorSolicitarCliente,
      orden: base.orden || base.ordenRespaldo || 0,
      idAdjunto,
      indicadorHabilitado,
    };
  }

  /**
   * Transforma un registro unificado tradicional (garantía, control o tercero) al modelo visual de la modal.
   */
  mapearAdjuntoAObjetoRequisito(adjunto: AdjuntoUnificado): any {
    const documentoAdmin = this.listaRespaldosAdicionalesTodos.find(
      (x) => x.codigo === adjunto.codigoDocumento
    );

    const respaldoInfo = !adjunto.indicadorTercero
      ? this.listaRespaldosAdicionalesTodos.find((r) => r.idDocumentoTercero === adjunto.idRespaldo)
      : null;

    const objBase = {
      nombreRespaldo: documentoAdmin?.nombre || adjunto.documento,
      idRespaldo: adjunto.idRespaldo,
      descripcionRespaldo: adjunto.descripcionAdjunto || documentoAdmin?.descripcion || documentoAdmin?.codigo,
      ordenRespaldo: respaldoInfo?.orden || 0,
      idAdjunto: adjunto.idAdjunto,
      indicadorHabilitadoAdjunto: this.calcularIndicadorHabilitado(adjunto),
      codigo: adjunto.codigoDocumento,
      adicional: !adjunto.indicadorObligatorio,
      indicadorRetoma: false,
      indicadorObligatorio: adjunto.indicadorObligatorio || false,
      indicadorTercero: adjunto.indicadorTercero || false,
      codigoTipoVigencia: adjunto.codigoTipoVigencia,
      fechaAdjunto: adjunto.fechaAdjunto,
      tipoVigencia: adjunto.tipoVigencia,
      validacionPermisos: this.validarPermisos(adjunto.codigoTipoVigencia, adjunto.indicadorVencido),
      indicadorSolicitarCliente: documentoAdmin?.indicadorSolicitarCliente || false,
      idDocumentoTercero: adjunto.idDocumentoTercero,
    };

    if (adjunto.indicadorTercero) {
      return {
        ...adjunto,
        ...objBase,
        idTerceroDocumentoTercero: adjunto.idTerceroDocumentoTercero,
        idDocumentoTercero: adjunto.idDocumentoTercero,
        objAdj: this.construirObjAdjTercero(adjunto),
        objAuxResp: this.construirObjAdjTercero(adjunto),
      };
    } else if (
      adjunto.codigoDocumento === "TOMFOT" ||
      adjunto.codigoDocumento === "ESCDOC"
    ) {
      return {
        ...adjunto,
        ...objBase,
        idSolicitudUCControlAdjunto: adjunto.idSolicitudUCControlAdjunto,
        objAdj: this.construirObjAdjControl(adjunto),
        objAuxResp: this.construirObjAdjRespaldo(adjunto),
      };
    } else {
      return {
        ...adjunto,
        ...objBase,
        idSolicitudUCRespaldoAdjunto: adjunto.idSolicitudUCRespaldoAdjunto,
        objAdj: this.construirObjAdjRespaldo(adjunto),
        objAuxResp: this.construirObjAdjRespaldo(adjunto),
      };
    }
  }

  calcularIndicadorHabilitado(adjunto: AdjuntoUnificado): boolean {
    if (!adjunto.idAdjunto) {
      return false;
    }
    if (adjunto.indicadorEliminacionManual === true) {
      return false;
    }
    return true;
  }

  construirObjAdjControl(adjunto: AdjuntoUnificado): any {
    return {
      idSolicitudUCControlAdjunto: adjunto.idSolicitudUCControlAdjunto,
      idAdjunto: adjunto.idAdjunto,
      codigoControl: adjunto.codigoDocumento,
      fechaAdjunto: adjunto.fechaAdjunto,
      indicadorHabilitado: this.calcularIndicadorHabilitado(adjunto),
      indicadorRetoma: adjunto.indicadorRetoma || false,
      idProductoControl: adjunto.idProductoControl,
      idSolicitudUnidadCredito : adjunto.idSolicitudUnidadCredito,
      descripcionAdjunto: adjunto.descripcionAdjunto,
      codigoDocumento: adjunto.codigoDocumento,
    };
  }

  construirObjAdjRespaldo(adjunto: AdjuntoUnificado): any {
    return {
      idSolicitudUCRespaldoAdjunto: adjunto.idSolicitudUCRespaldoAdjunto,
      idRespaldo: adjunto.idRespaldo,
      idAdjunto: adjunto.idAdjunto,
      codigoRespaldo: adjunto.codigoDocumento,
      fechaAdjunto: adjunto.fechaAdjunto,
      nombreRequisito: adjunto.documento,
      indicadorHabilitado: this.calcularIndicadorHabilitado(adjunto),
      indicadorRetoma: adjunto.indicadorRetoma || false,
      indicadorEliminacionManual: adjunto.indicadorEliminacionManual || false,
      descripcionAdjunto: adjunto.descripcionAdjunto,
      codigoDocumento: adjunto.codigoDocumento,
    };
  }

  /**
   * Filtra el catálogo de documentos disponibles para agregar, omitiendo los ya existentes en el expediente.
   */
  cargarAdicionales(): void {
    this.listaRespaldosAdicionales = [];
    this.listaRespaldosAdicionalesTodos.forEach(e => {
      if (
        !this.listaAdjuntos.find(x => x.idRespaldo === e.idDocumentoTercero || x.idDocumentoTercero === e.idDocumentoTercero) &&
        !this.listaAdjuntos.find(x => x.codigo === e.codigo)
      ) {
        this.listaRespaldosAdicionales.push({ label: e.nombre, value: e.idDocumentoTercero });
      }
    });
    this.listaAdjuntos = this.listaAdjuntos.sort((a, b) => a.ordenRespaldo - b.ordenRespaldo);
    this.clasificarListas();
  }

  /**
   * Separa los adjuntos en 'Mínimos Requeridos' (obligatorios) y 'Adicionales' (opcionales),
   * aplicando el filtro de búsqueda por texto.
   */
  clasificarListas(): void {

    const normalizar = (texto: string): string =>
      texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()

    const filtro = normalizar(this.textoBusqueda);
    const filtrado = filtro
      ? this.listaAdjuntos.filter(x =>
        normalizar(x.nombreRespaldo ?? '').includes(filtro) || normalizar(x.descripcionRespaldo ?? '').includes(filtro))
      : this.listaAdjuntos;

    this.listaMinimos = filtrado.filter(x => x.indicadorObligatorio);
    this.listaAdicionales = filtrado.filter(x => !x.indicadorObligatorio);
  }

  onBusqueda(): void {
    this.clasificarListas();
  }

  /**
   * Marca o desmarca masivamente los documentos pendientes habilitados para solicitar retoma.
   */
  toggleTodos(event: any): void {
    if (event) {
      this.listaAdjuntos.forEach(e => {
        const puedeSolicitar = this.esPasarela || e.indicadorSolicitarCliente;
        if (puedeSolicitar && !e.idAdjunto) {
          e.indicadorRetoma = event.checked;
        }
      });
    }
  }

  /**
   * Actualiza el checkbox general 'Seleccionar todos' según el estado de los ítems individuales.
   */
  checkIndicadorTodos(event: any): void {
    if (event) {
      if (event.checked) {
        const habilitados = this.listaAdjuntos.filter(x => (this.esPasarela || x.indicadorSolicitarCliente) && !x.idAdjunto);
        const buscar = habilitados.find(x => !x.indicadorRetoma);
        if (!buscar && habilitados.length > 0) { this.checkTodos = true; }
      } else {
        this.checkTodos = false;
      }
    }
  }

  /**
   * Captura el archivo seleccionado y su nombre antes de la subida.
   */
  onSelect(event: any, files: any): void {
    this.cargando = true;
    this.nomArchivo = files[0].name;
  }

  /**
   * Prepara la subida en el servicio de archivos, direccionando a 'AdmsbTitularAdjuntos' en Pasarela.
   */
  onBeforeSend(event: any) {
    if (this.showModalAdjunto) this.loadingFile = true;
    this.adjService.cargarArchivo(
      event,
      this.nomArchivo,
      this.esPasarela ? "AdmsbTitularAdjuntos" : "RequisitosRespaldos"
    );
  }

  /**
   * Procesa la subida del archivo. En Pasarela crea la versión calificada del adjunto;
   * en crédito sincroniza el control, respaldo o tercero correspondiente.
   */
  async onUpload(event: any, row: any): Promise<void> {
    this.cargando = true;
    try {
      const respuesta = event?.originalEvent?.body;
      const idAdjunto = respuesta?.idAdjunto;
      if (!idAdjunto) {
        row.idAdjunto = null;
        return;
      }

      if (this.esPasarela) {
        await firstValueFrom(
          this.terceroUpPasarelaAdjuntoService.crearAdjuntoVersion(
            this.construirRegistroAdjuntoPasarela(row, idAdjunto, true)
          )
        );
      } else if (row.indicadorTercero) {
        if (!row.idTerceroDocumentoTercero) {
          const docRel = {
            idTerceroDocumentoTercero: null,
            idTercero: this.solUnidadCredito.idTercero,
            idDocumentoTercero: row.idDocumentoTercero,
            idAdjunto: idAdjunto,
            indicadorHabilitado: true
          } as TerceroDocumentoRelacion;
          const resp = await firstValueFrom(this.terceroAdjuntoService.addDocumentoRelacionTercero(docRel));
          row.idTerceroDocumentoTercero = resp.idTerceroDocumentoTercero;
        } else {
          const docRel = {
            idTerceroDocumentoTercero: row.idTerceroDocumentoTercero,
            idTercero: this.solUnidadCredito.idTercero,
            idDocumentoTercero: row.idDocumentoTercero,
            idAdjunto: idAdjunto,
            indicadorHabilitado: true
          } as TerceroDocumentoRelacion;
          await firstValueFrom(this.terceroAdjuntoService.updateDocumentoRelacionTercero(docRel));
        }
      } else if (row.codigo === 'TOMFOT' || row.codigo === 'ESCDOC') {
        if (!row.idSolicitudUCControlAdjunto) {
          const control = this.listaControles.find(x => x.codigo === row.codigo);
          const prodCtrl = await firstValueFrom(this.prodControlService.obtenerProductoControlPorCodigoCtrlFaseYProducto(
            control.idControl,
            this.idFase,
            this.idProducto
          ));
          if (prodCtrl) {
            const ctrlAdjunto = {
              idSolicitudUCControlAdjunto: null,
              idAdjunto: idAdjunto,
              idProductoControl: prodCtrl.idProductoControl,
              idSolicitudUnidadCredito: this.solUnidadCredito.idSolicitudUnidadCredito,
              indicadorHabilitado: true,
              indicadorConsulta: false,
              resultado: null,
              indicadorCalificacion: null,
              indicadorViabilidad: false,
              auditoriaUsuario: null,
              auditoriaFecha: new Date()
            } as SolicitudUnidadCreditoControlAdjunto;
            const resp = await firstValueFrom(this.solUcControlAdjuntoService.crear(ctrlAdjunto));
            row.idSolicitudUCControlAdjunto = resp.idSolicitudUCControlAdjunto;
          }
        } else {
          const ctrlAdjunto = {
            ...row.objAdj,
            idAdjunto: idAdjunto,
            indicadorHabilitado: true
          } as SolicitudUnidadCreditoControlAdjunto;
          await firstValueFrom(this.solUcControlAdjuntoService.actualizar(ctrlAdjunto));
        }
      } else {
        if (!row.idSolicitudUCRespaldoAdjunto) {
          const resp = await firstValueFrom(this.solicitudUcRespaldoAdjuntoService.crear({
            idSolicitudUCRespaldoAdjunto: null,
            idSolicitudUnidadCredito: this.solUnidadCredito.idSolicitudUnidadCredito,
            idRespaldo: row.idRespaldo,
            idAdjunto: idAdjunto,
            indicadorHabilitado: true,
            indicadorEliminacionManual: false,
            auditoriaUsuario: null,
            auditoriaFecha: new Date(),
            descripcionAdjunto: row.descripcion
          } as SolicitudUcRespaldoAdjunto));
          row.idSolicitudUCRespaldoAdjunto = resp.idSolicitudUCRespaldoAdjunto;
        } else {
          const respAdj = {
            ...row.objAdj,
            idAdjunto: idAdjunto,
            indicadorHabilitado: true,
            indicadorEliminacionManual: false,
            idSolicitudUnidadCredito: this.solUnidadCredito.idSolicitudUnidadCredito
          } as SolicitudUcRespaldoAdjunto;
          await firstValueFrom(this.solicitudUcRespaldoAdjuntoService.actualizar(respAdj));
        }
      }
      row.idAdjunto = idAdjunto;
      row.nombreAdjunto = this.nomArchivo;
      row.indicadorHabilitadoAdjunto = true;
      this.navService.setMesage(2);
      await this.cargarRequisitos();
      this.cargarAdicionales();
      if (this.showModalAdjunto) this.verAdjunto(row);
    } catch (e) {
      console.error(e);
    } finally {
      this.cargando = false;
    }
  }

  /**
   * Solicita confirmación e inhabilita el documento en el expediente (inhabilitarAdjunto en Pasarela).
   */
  async eliminarAdjunto(row: any): Promise<void> {
    const eliminarAdjunto = row.idAdjunto ? true : false; // Si es false, se va a eliminar es el registro (Solo para opcionales)
    const mensaje = this.esPasarela
      ? this.navService.buscarMensaje("MSG_INHABILITARAdjunto")
      : row.indicadorTercero
      ? this.navService.buscarMensaje("MSG_INHABILITARAdjuntoTercero")
      : eliminarAdjunto
      ? this.navService.buscarMensaje("MSG_INHABILITARAdjunto")
      : this.navService.buscarMensaje("MSG_ELIMINARREQUISITO");

    this.confirmService.confirm({
      message: mensaje,
      header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
      icon: "fa fa-question-circle",
      key: "inhabilitar-adjunto",
      accept: async () => {
        this.cargando = true;
        try {
          if (this.esPasarela) {
            await firstValueFrom(
              this.terceroUpPasarelaAdjuntoService.inhabilitarAdjunto(
                this.construirRegistroAdjuntoPasarela(row, null, false)
              )
            );
          } else if (row.indicadorTercero) {
            const docRel = {
              idTerceroDocumentoTercero: row.idTerceroDocumentoTercero,
              idTercero: this.solUnidadCredito.idTercero,
              idDocumentoTercero: row.idDocumentoTercero,
              idAdjunto: null,
              indicadorHabilitado: eliminarAdjunto
            } as TerceroDocumentoRelacion;
            await firstValueFrom(this.terceroAdjuntoService.updateDocumentoRelacionTercero(docRel));
          } else if (row.codigo === 'TOMFOT' || row.codigo === 'ESCDOC') {
            const ctrlAdjunto = {
              ...row.objAdj,
              idAdjunto: null,
              indicadorHabilitado: eliminarAdjunto
            } as SolicitudUnidadCreditoControlAdjunto;
            await firstValueFrom(this.solUcControlAdjuntoService.actualizar(ctrlAdjunto));
          } else {
            const respAdj = {
              ...row.objAdj,
              idAdjunto: null,
              indicadorHabilitado: eliminarAdjunto,
              indicadorEliminacionManual: true,
              idSolicitudUnidadCredito: this.solUnidadCredito.idSolicitudUnidadCredito
            } as SolicitudUcRespaldoAdjunto;
            await firstValueFrom(this.solicitudUcRespaldoAdjuntoService.actualizar(respAdj));
          }
          this.navService.setMesage(2);
          await this.cargarRequisitos();
          this.cargarAdicionales();
        } catch (e) {
          console.error(e);
        } finally {
          this.cargando = false;
        }
      }
    });
  }

  verAdjunto(data: any): void {
    if (this.esPasarela) {
      this.adjuntoSeleccionadoPasarela = data;
      this.mostrarVisorPasarela = true;
    } else {
      this.verRegistro = data;
      this.cargarAdjuntoVista(data.idAdjunto, data.indicadorTercero);
      this.showModalAdjunto = true;
    }
  }

  /**
   * Refresca los requisitos cuando se aprueba o rechaza un adjunto desde el visor pasarela
   */
  async onAdjuntoCalificado(event: any): Promise<void> {
    await this.cargarRequisitos();
    this.cargarAdicionales();
  }

  cargarAdjuntoVista(idAdjunto: string, indicadorTercero: boolean): void {
    this.loadingFile = true;
    if (idAdjunto) {
      forkJoin([
        this.adjService.descargarArchivo(idAdjunto, indicadorTercero)
      ]).subscribe(([adjunto]) => {
        if (this.verRegistro) { this.verRegistro.file = adjunto; }
        const blob = URL.createObjectURL(adjunto);
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blob);
        this.loadingFile = false;
      }, () => { this.loadingFile = false; });
    } else if (this.verRegistro && this.verRegistro.file) {
      const blob = URL.createObjectURL(this.verRegistro.file);
      this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blob);
      this.loadingFile = false;
    }
  }

  cerrarModalAdjunto(): void {
    this.verRegistro = null;
    this.showModalAdjunto = false;
    this.fileUrl = null;
  }

  /**
   * Valida y guarda un nuevo documento adicional en el expediente (crearAdjuntoVersion en Pasarela).
   */
  async guardarNuevoRequisito(): Promise<void> {
    this.submitted = true;
    if (this.formulario.invalid) {
      return;
    }

    this.cargando = true;
    try {
      const registro = this.formulario.value;
      if (this.esPasarela) {
        const doc = this.listaRespaldosAdicionalesTodos.find((x) => x.idDocumentoTercero === registro.idRequisito);
        if (doc) {
          await firstValueFrom(
            this.terceroUpPasarelaAdjuntoService.crearAdjuntoVersion(
              this.construirRegistroAdjuntoPasarela(doc, null, true)
            )
          );
        }
      } else {
        const documentoTercero = this.listaRespaldosAdicionalesTodos.find((x) => x.idDocumentoTercero === registro.idRequisito);
        const idDocumento = documentoTercero.idDocumentoTercero;

        await firstValueFrom(this.solicitudUcRespaldoAdjuntoService.agregarRequisito(
          idDocumento,
          this.solUnidadCredito.idSolicitudUnidadCredito,
          registro.descripcion
        ));
      }

      this.verPantallaAgregar = false;
      this.submitted = false;
      this.formulario.reset();
      this.navService.setMesage(2);
      await this.cargarRequisitos();
      this.cargarAdicionales();
    } catch (error) {
      console.error('Error al crear:', error);
    } finally {
      this.cargando = false;
    }
  }

  cancelarNuevoRequisito(): void {
    this.verPantallaAgregar = false;
    this.submitted = false;
    this.formulario.reset();
  }

  validarPermisos(codigoTipoVigencia: any, indicadorVencido: boolean): boolean {
    if (!this.permisoGestionAdjuntos) {
      if (
        codigoTipoVigencia === TipoVigencia.VITALI ||
        (codigoTipoVigencia === TipoVigencia.TEMPO && (!indicadorVencido && indicadorVencido !== null))
      ) {
        return false;
      }
    }
    return true;
  }

  construirObjAdjTercero(adjunto: AdjuntoUnificado): any {
    return {
      idTerceroDocumentoTercero: adjunto.idTerceroDocumentoTercero,
      idAdjunto: adjunto.idAdjunto,
      idDocumentoTercero: adjunto.idDocumentoTercero,
      codigoDocumento: adjunto.codigoDocumento,
      fechaAdjunto: adjunto.fechaAdjunto,
      indicadorHabilitado: this.calcularIndicadorHabilitado(adjunto),
      indicadorRetoma: adjunto.indicadorRetoma || false,
      descripcionAdjunto: adjunto.descripcionAdjunto,
    };
  }

  cerrar(): void {
    this.ref.close();
  }

  getEstadoBadgeClass(item: any): string {
    if (this.esPasarela) {
      if (!item.idAdjunto) {
        return 'badge-pendiente';
      }
      if (item.indicadorCalificacion === false) {
        return 'badge-rechazado';
      }
      return 'badge-cargado';
    }

    if (item.idAdjunto) {
      return 'badge-cargado';
    }
    return 'badge-pendiente';
  }

  getEstadoLabel(item: any): string {
    if (this.esPasarela) {
      if (!item.idAdjunto) {
        return this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_PENDIENTE_VERIFICABLE');
      }
      if (item.indicadorCalificacion === false) {
        return this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_CARGADO_RECHAZADO');
      }
      return this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_CARGADO_VERIFICABLE');
    }

    const estado = item.idAdjunto
      ? this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_CARGADO')
      : this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_PENDIENTE');
    const vigencia = item.tipoVigencia || this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_VERIFICABLE');
    return `${estado} - ${vigencia}`;
  }

  get esContextoMatrix(): boolean {
    return !!(this.idSolicitud || this.solUnidadCredito?.idSolicitudUnidadCredito);
  }

  construirPayloadRetomaBulk(seleccionados: any[]): TerceroUPPasarelaAdjunto[] {
    return seleccionados.map(item => {
      const base = item.objOriginal ? { ...item.objOriginal } : { ...item };
      return {
        ...base,
        indicadorRetoma: true,
      };
    });
  }

  async guardarRetomaPasarelaBulk(seleccionados: any[]): Promise<null> {
    const payloadBulk = this.construirPayloadRetomaBulk(seleccionados);
    if (this.esContextoMatrix) {
      await firstValueFrom(this.terceroUpPasarelaAdjuntoService.guardarAdjuntosSolicitudBulk(payloadBulk));
    } else {
      await firstValueFrom(this.terceroUpPasarelaAdjuntoService.guardarAdjuntosTerceroBulk(payloadBulk));
    }
    return null;
  }

  get hasIndicadorRetoma(): boolean {
    return this.listaAdjuntos && this.listaAdjuntos.some(x => x.indicadorRetoma === true);
  }

  /**
   * Valida la selección y envía la solicitud de retoma autogestionada al cliente.
   * En Pasarela despacha directamente con idTerceroUPPasarela sin bloquear por estado terminal.
   */
  async enviarRetoma(): Promise<void> {
    const selectedReqs = this.listaAdjuntos.filter(x => x.indicadorRetoma);
    if (selectedReqs.length === 0) {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.LBL_SELECCIONEUNDOCUMENTO')
      });
      return;
    }

    this.confirmService.confirm({
      message: this.navService.buscarMensaje('MATRIXADJUNTOSMODAL.MSG_ENVIORETOMAADJUNTO'),
      header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
      icon: "fa fa-question-circle",
      key: "inhabilitar-adjunto",
      accept: async () => {
        this.cargando = true;
        try {
          if (this.esPasarela) {
            const enviarLink = await firstValueFrom(
              this.solicitudUnidadCreditoService.enviarRetoma(
                await this.guardarRetomaPasarelaBulk(selectedReqs),
                this.medioNotificacionSelected,
                this.idTerceroUPPasarela
              )
            );

            if (enviarLink && enviarLink.estado) {
              this.navService.setMesage(0, {
                severity: 'info',
                summary: this.navService.buscarMensaje('LBL_INFORMACION'),
                detail: this.navService.buscarMensaje('REQUISITOS.LBL_NOTENVIADA')
              });
            } else {
              this.navService.setMesage(0, {
                severity: 'error',
                summary: this.navService.buscarMensaje('LBL_ERROR'),
                detail: this.navService.buscarMensaje('LBL_MSGERRORSERVICIO')
              });
            }
          } else {
            const codigos = selectedReqs.map(x => x.codigo);
            await firstValueFrom(this.solicitudUcRespaldoAdjuntoService.solicitarAlCliente(this.solUnidadCredito.idSolicitudUnidadCredito, codigos));

            const enviarLink = await firstValueFrom(
              this.solicitudUnidadCreditoService.enviarRetoma(
                this.solUnidadCredito.idSolicitudUnidadCredito,
                this.medioNotificacionSelected
              )
            );

            if (enviarLink && enviarLink.estado) {
              this.navService.setMesage(0, {
                severity: 'info',
                summary: this.navService.buscarMensaje('LBL_INFORMACION'),
                detail: this.navService.buscarMensaje('REQUISITOS.LBL_NOTENVIADA')
              });
            } else {
              this.navService.setMesage(0, {
                severity: 'error',
                summary: this.navService.buscarMensaje('LBL_ERROR'),
                detail: this.navService.buscarMensaje('LBL_MSGERRORSERVICIO')
              });
            }
          }
        } catch (error) {
          console.error(error);
          this.navService.setMesage(0, {
            severity: 'error',
            summary: this.navService.buscarMensaje('LBL_ERROR'),
            detail: this.navService.buscarMensaje('LBL_MSGERRORSERVICIO')
          });
        } finally {
          this.cargando = false;
        }
      }
    });
  }
}

